import globalColors from './globalColors.scss';

export const borders = {
    error: `0.5px solid ${globalColors.alertColor}`,
    defaultInput: `0.5px solid ${globalColors.backgroundColor2}`,
};

export default borders;
